import * as React from "react";
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CSSFixedColumns } from './CssFixedColumns';

export class MonthlyPresenceTableTds extends React.Component {

    render() {
        const {worker} = this.props;
        const completeName = worker.completeName();

        return (
            <td className={'fixed-td'}>
                <div
                    className={'fixed-pseudo-td ellipsis'}
                    children={worker.dni()}
                    style={CSSFixedColumns.WORKER_DNI}
                />
                <OverlayTrigger
                    placement={'bottom'}
                    overlay={
                        <Tooltip
                            id={'tooltip-worker'}
                            children={completeName}
                        />
                    }
                >
                    <div
                        className={'fixed-pseudo-td ellipsis'}
                        children={completeName}
                        style={CSSFixedColumns.WORKER_NAME}
                    />
                </OverlayTrigger>
                <div
                    className={'fixed-pseudo-td ellipsis'}
                    children={worker.company().name()}
                    style={CSSFixedColumns.WORKER_COMPANY}
                />
            </td>
        );
    }
}

MonthlyPresenceTableTds.propTypes = {
    worker: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/components/table/MonthlyPresenceTableTds.jsx